import React, { useState, useEffect } from "react";
import Footer from "../landingPage/footer";
import "./AICreator.scss";
import FileConstants from "../../FileConstants";
import TextConstants from "../../TextConstants";
import MetaTagContents from "../../MetaTagContents";
import NavBar from "../landingPage/header/navbar";
import { Button, Layout } from "antd";
import { useLocation } from "react-router-dom";
import { ArrowRightOutlined } from "@ant-design/icons";
import SignUpModal from "./SignUpModal";
import { PORTAL_BASE_URL, CALENDLY_LINK } from "../../env";
import { trackCta } from "../../analytics";
import BrandsCarousel from "../pricingV2/components/BrandsCarousel/BrandsCarousel";
import StatsSection from "./StatsSection";
import JoinFutureSection from "./JoinFutureSection";
import HowItWorksSection from "./HowItWorksSection";
import TestimonialsSection from "./TestimonialsSection";
import ComparisonSection from "./ComparisonSectionAICreator";
import Metrics from "../SMBLandingPage/Metrics/Metrics";
import BookendSection from "../SMBLandingPage/BookendSection/BookendSection";
import PricingSection from "./PricingSection";

const { Content } = Layout;


const HeroSection = () => {
    const utm_source = localStorage.getItem('utm_source') || null;
    const images = [
        "/ai_creator/hero_slideshow/hero-img1.jpg",
        "/ai_creator/hero_slideshow/hero-img2.jpg",
        "/ai_creator/hero_slideshow/hero-img3.jpg",
        "/ai_creator/hero_slideshow/hero-img4.jpg",
        "/ai_creator/hero_slideshow/hero-img5.jpg",
        "/ai_creator/hero_slideshow/hero-img6.jpg",
    ];

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <div className="ai-mobile-hero-section">
            <div className="ai-mobile-hero-content">
                <div className="ai-mobile-badge">
                    <img src='/ai_creator/ai-creator-twinkle.svg' alt="AI Creator icon" />
                    <span className="manrope">AI Creator by ALL3D</span>
                </div>

                <h1 className="ai-mobile-hero-title manrope">
                    One AI workflow for quality, on-brand product images <span className="blue-gradient">in minutes</span>
                </h1>

                <p className="ai-mobile-hero-description manrope">
                    Create high-quality visuals from the best AI image models for your product—without tool-hopping, prompt chaos, or endless revisions.
                </p>

                <div className="ai-mobile-hero-actions">
                    <Button
                        className="ai-mobile-primary-btn manrope"
                        onClick={() => {
                            trackCta('free_trial_click', {
                                section: 'hero',
                                placement: 'mobile',
                                button: 'get_started_for_free',
                            });

                            const urlParams = new URLSearchParams(window.location.search);
                            const urlUtmSource = urlParams.get('utm_source');
                            const email = urlParams.get('email');
                            const finalUtmSource = urlUtmSource || localStorage.getItem('utm_source');
                            let targetUrl = `${PORTAL_BASE_URL}/register?redirectURL=ai-asset-creator`;
                            if (finalUtmSource) targetUrl += `&utm_source=${finalUtmSource}`;
                            if (email) targetUrl += `&email=${email}`;
                            window.open(targetUrl, "_blank");
                        }}
                    >
                        Get started for free
                    </Button>
                    <Button
                        className="ai-mobile-secondary-btn manrope"
                        onClick={() => {
                            trackCta('schedule_demo_click', {
                                section: 'hero',
                                placement: 'mobile',
                                button: 'schedule_a_demo',
                            });
                            window.open(CALENDLY_LINK, "_blank")
                        }}

                    >
                        Schedule a demo
                    </Button>
                </div>
            </div>

            <div className="ai-mobile-hero-image-container">
                <div className="hero-image-slider">
                    {images.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`AI Generated Lifestyle ${index + 1}`}
                            className="ai-mobile-hero-image"
                            style={{
                                position: index === 0 ? 'relative' : 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                opacity: currentImageIndex === index ? 1 : 0,
                                transition: 'opacity 1.5s ease-in-out',
                                zIndex: currentImageIndex === index ? 2 : 1
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}


const AICreatorMobile = () => {
    return (
        <Content className="d-lg-none mt-16">
            <HeroSection />
            <BrandsCarousel />
            <HowItWorksSection />
            <ComparisonSection />
            <PricingSection />
            <TestimonialsSection />
            <Metrics />
            <BookendSection />
        </Content>
    );
}


export default AICreatorMobile;
